import React from 'react';
import PropTypes from 'prop-types';
import OkButton from 'components/common/OkButton';

import { CancelIcon, CircleCheckIcon as CheckCircleIcon, InfoIcon, WarningIcon, QuestionIcon } from 'components/icons';

const icons = {
	error: CancelIcon,
	info: InfoIcon,
	question: QuestionIcon,
	success: CheckCircleIcon,
	warning: WarningIcon,
};

const ConfirmDialog = props => {
	const {
		className = '',
		classNameIcon = '',
		classNameContainer,
		classNameButton,
		message,
		onOk,
		severity = 'info',
	} = props;

	const icon = <span className={classNameIcon}>{icons[severity]}</span>;
	const action = <OkButton classNameContainer={classNameContainer} classNameButton={classNameButton} onOk={onOk} />;

	return (
		<div className={className}>
			{icon}
			{message}
			{action}
		</div>
	);
};

ConfirmDialog.propTypes = {
	className: PropTypes.string,
	classNameCloseButton: PropTypes.string,
	classNameIcon: PropTypes.string,
	classNameYesNoContainer: PropTypes.string,
	classNameYesButton: PropTypes.string,
	classNameNoButton: PropTypes.string,
	handleClose: PropTypes.func,
	message: PropTypes.string.isRequired,
	onOk: PropTypes.func.isRequired,
	severity: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'question']),
};

export default ConfirmDialog;
